<template lang="pug">
div
  h3.capitalize Welivery

  .input-container
    input.input(v-model="order" @keyup.enter="getData" type="text")
    label.label(:class="{ show: order }") Introduce el número de orden

  button.button.button-shadow.capitalize.bg-principal(@click="getData") Traer Datos

  h3.capitalize Datos
  .table
    table
      thead
        tr.dark
          td ID
          td Dirección de Retiro
          td Detalles de Retiro
          td Localidad de Retiro
          td CP de Retiro
          td Nombre y Apellido de Retiro
          td Teléfono de Retiro
          td Dirección de Entrega
          td Detalles de Entrega
          td Localidad de Entrega
          td CP de Entrega
          td Nombre y Apellido
          td Teléfono de Entrega
          td Email de Entrega
      tbody
        tr(v-for="(order, index) in orders")
          td(@click="deleteOrder(index)") {{ order.change ? `c${order.change}` : order.order }}
          td Calle 37 b sur 68i 23 piso 1
          td Paquete
          td Kennedy
          td 1
          td Sofía Matallana
          td 3507501085
          td.uppercase {{ order.address }}
          td {{ order.change ? '' : `Productos: ${getQuantity(order.cart)}` }}
          td {{ order.locationCity || '-' }}
          td 1
          td.capitalize {{ order.name }}
          td {{ order.phones[0] }}
          td {{ order.email }}
</template>

<script>
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlChange from '@/graphql/change'
import modals from '@my/store/modals'

export default {
  name: 'Welivery',

  mixins: [mFilters],

  props: {
    change: Object
  },

  data () {
    return {
      order: '',
      orders: []
    }
  },

  methods: {
    async getData () {
      if (!this.order) return
      const isOrder = this.order[0] === 's'

      if (isOrder) {
        await this.getDataOrder(this.order)
      } else {
        const change = this.order.slice(1)
        await this.getDataChange(change)
      }
    },

    async getDataOrder (order) {
      const query = gqlOrder.GET_ALL
      const variables = { search: order, searchBy: 'order', limit: 1, page: 1, sort: 'createdAt', order: '-' }

      const response = await gql.query(query, variables, true)
      const docs = response.data.getOrders.docs

      if (!docs.length) {
        modals.showMessage({ message: `No se encontró la orden ${this.order}` })
      } else {
        const orderFound = docs[0]
        const indexOrder = this.orders.findIndex(order => order.order === orderFound.order)

        if (indexOrder >= 0) {
          this.orders[indexOrder] = orderFound
          return
        }

        this.orders.push(orderFound)
        this.order = ''
      }
    },

    async getDataChange (change) {
      const query = gqlChange.GET_ALL
      const variables = { search: change, searchBy: 'change', limit: 1, page: 1, sort: 'createdAt', order: '-' }

      const response = await gql.query(query, variables, true)
      const docs = response.data.getChanges.docs

      if (!docs.length) {
        modals.showMessage({ message: `No se encontró el cambio ${this.order}` })
      } else {
        const changeFound = docs[0]
        const indexChange = this.orders.findIndex(order => order.order === changeFound.change)

        if (indexChange >= 0) {
          this.orders[indexChange] = changeFound
          return
        }

        this.orders.push(changeFound)
        this.order = ''
      }
    },

    getQuantity (cart) {
      let totals = { quantity: 0, priceUnit: 0, priceThree: 0, priceWholesaler: 0, priceSale: 0 }

      totals = cart.reduce((total, product) => {
        const quantity = product.quantityCart.reduce((a, b) => a + b, 0)
        total.quantity += quantity
        total.priceUnit += product.priceUnit * quantity
        total.priceThree += product.priceThree * quantity
        total.priceWholesaler += product.priceWholesaler * quantity
        total.priceSale += product.priceSale * quantity

        return total
      }, { quantity: 0, priceUnit: 0, priceThree: 0, priceWholesaler: 0, priceSale: 0 })

      return totals.quantity
    },

    deleteOrder (index) {
      this.orders.splice(index, 1)
    }
  }
}
</script>

<style lang="stylus">
.table
  overflow scroll
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Welivery.vue